import { defineMessages } from 'react-intl'

const messages = defineMessages({
  absoluteValuesEvolution: {
    id: 'ChartTypeFilter.absoluteValuesEvolution',
    description: 'Texto para elegir el tipo de gráfico',
    defaultMessage: 'Evolución valores absolutos'
  },
  map: {
    id: 'ChartTypeFilter.map',
    description: 'Texto para elegir el tipo de gráfico',
    defaultMessage: 'Mapa'
  }
})
export default messages



// WEBPACK FOOTER //
// ./src/modules/Filters/ChartTypeFilter/messages.js